import React from 'react';
import {  useSelector } from 'react-redux';
import PoweredLabel from '@gumtree/ui-library/src/powered-label';
import ScoreReviews from '@gumtree/ui-library/src/score-reviews/score-reviews';
import NoImg from './no-img.svg'
import { VipState } from '../../reducers';
import { 
    BarkCardWrapper, 
    AvatarImage, 
    CompanyName,
    InfoContainer,
    NoImgWrapper
} from './index.style';
import { PoweredLabelWrapper } from '../new-contact-card/index.style';

interface BarkProfileCardProps {
    scoreAndReviews: {
        average: number;
        total: number;
    };
    adSource: string;
    isMobile: boolean;
}

const BarkProfileCard: React.FC<BarkProfileCardProps> = ({ scoreAndReviews, adSource, isMobile }) => {
    const {
        adDetails: {
            sellerOtherAds,
        },
        sellerContactDetails: {
            contactName,
        },
        images,
    } = useSelector((state: VipState) => state);

    const profileImg = images?.length > 0 ? images[0] : '';

    return (
        <BarkCardWrapper>
            {profileImg ? <AvatarImage src={profileImg} alt={`${contactName} avatar`} /> : <NoImgWrapper><NoImg /></NoImgWrapper>}
            
            <InfoContainer>
                <CompanyName href={sellerOtherAds} target="_blank" rel="noopener noreferrer">
                    {contactName}
                </CompanyName>
                
                {scoreAndReviews && (
                    <> 
                        {scoreAndReviews.average > 0 && scoreAndReviews.total > 0 && (
                            <ScoreReviews
                                score={scoreAndReviews.average}
                                reviewCount={scoreAndReviews.total}
                                type="vip"
                                isMobile={isMobile}
                            />
                        )}
                        {adSource === 'Bark' && (
                            <PoweredLabelWrapper type="vip" isMobile={isMobile}>
                                <PoweredLabel type={adSource} withInfo pageType="vip" isMobile={isMobile}/>
                            </PoweredLabelWrapper>
                        )}
                    </>
                )}
            </InfoContainer>
        </BarkCardWrapper>
    );
};

export default BarkProfileCard;
